import { Box, Card, CardContent, Typography } from "@mui/material";
import { IExamFilesLogItem } from "../../../../models/exam-files-log";
import { useTranslation } from "react-i18next";
const translationPath = "page.4uBus.logs.logFileIntegration.";

const LogFileIntegrationModal = ({ items }: { items: IExamFilesLogItem[] }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ padding: 2 }}>
      {items.map((item, index) => (
        <Card key={index} variant="outlined" sx={{ marginBottom: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              {t(translationPath + "view_logs")}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
              }}
            >
              {item.fileName}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default LogFileIntegrationModal;
